import { HttpContextToken } from '@angular/common/http';

export const ANONYMOUS_REQUEST = new HttpContextToken<boolean>(() => false);
